import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { CommentTemplate } from '../../models/CommentTemplate';

const COMMENT_TEMPLATE_URL = '/api/v1/offers/templates/notes';

const useCommentTemplatesSWR = () => {
    const fetcher = (query): Promise<CommentTemplate[]> => {
        return httpApi
            .get<{ notes: CommentTemplate[] }>(query)
            .then((res) => {
                return res.getData().notes;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        COMMENT_TEMPLATE_URL,
        fetcher,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        comments: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useCommentTemplatesSWR;
